import { Link, type Href } from 'expo-router'
import type { ComponentProps, ReactNode } from 'react'
import { Pressable } from './ui/pressable'
import { Spinner } from './ui/spinner'
import { Text } from './ui/text'
import { VStack } from './ui/vstack'

type ActionCardProps = {
  title: string
  titleProps?: ComponentProps<typeof Text>
  icon?: ReactNode
  danger?: boolean
  link?: Href
  replace?: boolean
  loading?: boolean
  onPress?: () => void
  className?: string
  detached?: boolean
}

export default function ActionCard({
  title,
  titleProps,
  icon,
  danger,
  link,
  replace,
  loading,
  onPress,
  className = '',
  detached,
}: ActionCardProps) {
  const titleText = (
    <Text
      size="body"
      {...titleProps}
      className={`leading-none ${danger ? 'text-error-400' : ''} ${titleProps?.className ?? ''}`}
    >
      {title}
    </Text>
  )

  const content = detached ? (
    <Pressable onPress={onPress}>
      <VStack space="sm" className="items-center">
        <VStack
              className={`bg-background-0 data-[active=true]:bg-background-100 rounded-3xl aspect-square items-center justify-center ${className}`}
        >
          {loading ? <Spinner /> : icon}
        </VStack>
        {titleText}
      </VStack>
    </Pressable>
  ) : (
    <Pressable
      onPress={onPress}
      className={`bg-background-0 data-[active=true]:bg-background-100 rounded-3xl w-full aspect-square ${className}`}
    >
      <VStack space="md" className="items-center justify-center h-full">
        {loading ? <Spinner /> : icon}
        {titleText}
      </VStack>
    </Pressable>
  )

  if (link) {
    return (
      <Link href={link} asChild replace={replace}>
        {content}
      </Link>
    )
  }

  return content
}
